"use client";

import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Link from "next/link";

import { Container } from "@/app/(marketing)/_components/ui/container";

import NotFoundBadge from "./not-found-badge";

export default function NotFoundHero() {
  return (
    <section className="relative px-5 pt-16 pb-28 md:px-8 md:pt-20 md:pb-32 lg:px-14">
      <Container>
        <motion.div
          initial={{ opacity: 0, transform: "translateY(20px)" }}
          animate={{ opacity: 1, transform: "translateY(0px)" }}
          transition={{ duration: 0.5 }}
          className="mx-auto flex w-full max-w-[914px] flex-col items-center gap-10 sm:gap-12"
        >
          <NotFoundBadge />

          <div className="flex flex-col items-center gap-5 text-center text-white">
            <h1 className="max-w-[820px] text-4xl leading-[1.05] font-medium tracking-tight text-balance sm:text-5xl md:text-[56px] md:leading-[1.05]">
              Page Not Found
            </h1>
            <p className="max-w-[620px] text-base leading-relaxed text-balance text-white/80 md:text-lg">
              The page you&apos;re looking for doesn&apos;t exist or has been
              moved.
            </p>
          </div>

          <div className="flex flex-col items-center gap-3">
            <Link
              href="/"
              className="text-marketing-blue group inline-flex h-12 items-center justify-center gap-2 rounded-full bg-white px-8 text-base font-medium transition-colors hover:bg-white/90"
            >
              Back to home
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
            <Link
              href="/me/opportunities"
              className="group inline-flex items-center gap-1.5 text-sm text-white/70 transition-colors hover:text-white"
            >
              Browse open studies instead
              <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </div>
        </motion.div>
      </Container>
    </section>
  );
}
